/* Copyright (c) 2024 Xperi. All Rights Reserved. */

export class CollectionFilters {
    public static readonly ALL_EPISODE_DETAIL = 'ALL_EPISODE_DETAIL';

    public static readonly GET_THIS_SHOW_DETAILS = 'GET_THIS_SHOW_DETAILS';

    public static readonly NONE = 'none';

    public static readonly ONEPASS_OPTIONS_DETAIL = 'ONEPASS_OPTIONS_DETAIL';

    public static readonly RECORDINGS_DETAILS = 'RECORDINGS_DETAILS';

    public static readonly UPCOMING_DETAIL = 'UPCOMING_DETAIL';

    public static readonly WATCH_LIST_DETAILS = 'WATCH_LIST_DETAILS';
}
